import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBe-Ox7qjR9plTbRyTrw5F2N4tF1ziNpmY",
  authDomain: "rap-scen.firebaseapp.com",
  projectId: "rap-scen",
  storageBucket: "rap-scen.appspot.com",
  messagingSenderId: "46202117116",
  appId: "1:46202117116:web:4e37b27def477781f27079"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const storage = firebase.storage();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { db, storage, timestamp, firebaseConfig };
